/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::006dceb418e831d7566ee430d605056b>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "PriorityCritical".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/priority-critical
 * Usage guidance:
 * Reserved for critical work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const PriorityCriticalIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  name: "PriorityCriticalIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" d="M12.837 14.836A.75.75 0 0 0 14 14.21v-9a.75.75 0 0 0-.337-.626l-5.25-3.46a.75.75 0 0 0-.826 0l-5.25 3.46A.75.75 0 0 0 2 5.21v9l.007.103a.75.75 0 0 0 1.156.523L8 11.65zm-4.424-4.713a.75.75 0 0 0-.826 0L3.5 12.818V5.614L8 2.65l4.5 2.965v7.204z"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
PriorityCriticalIcon.displayName = 'PriorityCriticalIcon';
var _default = exports.default = PriorityCriticalIcon;